<script>
  import AlertCircle from '@/assets/alert-circle.svg';
  import OrderTable from '@/components/Transaction/Order/Table';

  export default {
    components: {
      OrderTable,
      AlertCircle,
    },
  };
</script>

<template>
  <article class="transaction-offer card">
    <header class="card__header">
      <h1 class="card__title">Book de ofertas</h1>
    </header>

    <OrderTable
      with-sum
      :size="14"
      class="transaction-offer__table card__body"
      />

    <p class="transaction-offer__spread">
      <AlertCircle v-tooltip="'Spread: <span>U$00,1 (90%)</span>'" /> Spread:<span>R$ 00,1</span>
    </p>

    <OrderTable
      with-sum
      negative
      :size="13"
      class="transaction-offer__table card__body"
      />
  </article>
</template>

<style lang="scss">
  .transaction-offer {
    &__table {
      table {
        font-size: 12px;
      }

      th {
        // override default style
        // use important here cause I don't wanna nest too much
        width: 25% !important;
      }
    }

    &__spread {
      color: #FFF;
      display: flex;
      font-size: 20px;
      padding: 20px 24px;
      align-items: center;
      letter-spacing: 0.4px;
      border: 1px solid rgba(147, 156, 172, 0.26);

      border-left: 0;
      border-right: 0;

      svg {
        width: 18px;
        height: 18px;
        margin-right: 12px;
      }

      span {
        margin-left: 16px;
      }
    }
  }
</style>
